<template>
    <div class="page_honor_mobile flex-col">

        <div class="group_34 flex-col">
            <div class="text-group_19 flex-col">
                <span class="text_52">多维度荣誉资质</span>
                <span class="text_53">康柏汉森已获业内多维度认证与资质，持续为客户创造价值</span>
            </div>
            <div class="box_15 flex-row justify-between">
                <div class="box_16 flex-row">
                    <div class="image-text_11 flex-col">
                        <img
                                class="image_11"
                                referrerpolicy="no-referrer"
                                src="../../assets/index/chpc_index_honor11.png"
                        />
                        <div class="text-group_20 flex-col">
                            <span class="text_54">信息安全管理体系认证证书</span>
                            <span class="text_55">ISO&nbsp;27001</span>
                        </div>
                    </div>
                </div>
                <div class="box_17 flex-row">
                    <div class="image-text_12 flex-col">
                        <img
                                class="image_12"
                                referrerpolicy="no-referrer"
                                src="../../assets/index/chpc_index_honor10.png"
                        />
                        <div class="text-group_20 flex-col">
                            <span class="text_56">质量管理体系认证证书</span>
                            <span class="text_55">ISO&nbsp;9001</span>
                        </div>
                    </div>
                </div>
                <!--
                <div class="box_17 flex-row">
                    <div class="image-text_12 flex-col">

                            <img
                                    class="image_11"
                                    referrerpolicy="no-referrer"
                                    src="../../assets/index/chpc_index_honor9.png"
                            />

                        <div class="text-group_20 flex-col">
                            <span class="text_58">多元化供应商</span>
                            <span class="text_55">MSD&nbsp;China</span>
                        </div>
                    </div>
                </div>
                -->
            </div>
            <div class="box_15 flex-row justify-between">
                <div class="box_16 flex-row">
                    <div class="image-text_11 flex-col">
                        <img
                                class="image_11"
                                referrerpolicy="no-referrer"
                                src="../../assets/index/chpc_index_honor8.png"
                        />
                        <div class="text-group_20 flex-col">
                            <span class="text_54">已进行科学碳目标设定</span>
                            <span class="text_55">SBTi</span>
                        </div>
                    </div>
                </div>
                <div class="box_18 flex-row">
                    <div class="image-text_13 flex-col">

                        <img
                                class="image_11"
                                referrerpolicy="no-referrer"
                                src="../../assets/index/chpc_index_honor4.png"
                        />

                        <div class="text-group_22 flex-col">
                            <span class="text_58">24-25获气候问卷B级</span>
                            <span class="text_55">CDP</span>
                        </div>
                    </div>
                </div>
                <div class="box_17 flex-row">
                    <div class="image-text_12 flex-col">
                        <img
                                class="image_11"
                                referrerpolicy="no-referrer"
                                src="../../assets/index/chpc_index_honor7.png"
                        />
                        <div class="text-group_20 flex-col">
                            <span class="text_56">企业社会责任认证单位</span>
                            <span class="text_55">EcoVdis</span>
                        </div>
                    </div>
                </div>


            </div>
            <div class="box_15 flex-row justify-center">
                <div class="box_17 flex-row">
                    <div class="image-text_12 flex-col">

                        <img
                                class="image_11"
                                referrerpolicy="no-referrer"
                                src="../../assets/index/chpc_index_honor6.png"
                        />
                        <div class="text-group_20 flex-col">
                            <span class="text_58">多项自研技术专利</span>
                            <span class="text_55">Patent</span>
                        </div>
                    </div>
                </div>
                <div class="box_16 flex-row">
                    <div class="image-text_11 flex-col">
                        <img
                                class="image_11"
                                referrerpolicy="no-referrer"
                                src="../../assets/index/chpc_index_honor5.png"
                        />
                        <div class="text-group_20 flex-col">
                            <span class="text_54">多个行业委员会成员企业</span>
                            <span class="text_55">ASSOCIATION</span>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {

            };
        },
        methods: {}
    };
</script>
<style scoped lang="css" >
    .page_honor_mobile {
        background-color: #fff;
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        min-height: 200px;
        overflow: hidden;
    }

    .group_34 {
        max-width: 1200px;
        margin: 0 auto;
        padding: 51px 0 40px;
    }

    .text-group_19 {
        text-align: center;
        max-width: 800px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_52 {
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        align-self: center;

        font-size: 3.5vw; /* 38px -> 2.5vw */
        line-height: 1.3;
        margin-bottom: 15px;
    }

    .text_53 {
        width: 100%;
        max-width: 483px;
        height: 74px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        text-align: center;

        font-size: 2.6vw; /* 26px -> 1.6vw */
        line-height: 1.5;
        margin: 0 auto;
    }

    .box_15 {
        align-self: center;
        margin-top: 0px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 2vw;
        max-width: 100%;
    }
    .box_15 > div {
        flex: 1;
        min-width: 150px;
        max-width: 300px;
        padding: 2px 20px 42px;
        box-sizing: border-box;
    }

    .image-text_11,
    .image-text_12,
    .image-text_13 {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }
    .image_12 {
        margin: 0 !important;
    }

    .box_16 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 9px;
        padding: 24px 22px 42px 23px;
    }


    .image_11 {
        width: 96px;
        height: 96px;
        align-self: center;
    }

    .text-group_20 {
        margin-top: 7px;
    }

    .text_54 {
        overflow-wrap: break-word;
        color: rgba(46, 45, 62, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 23px;
    }

    .text_55 {
        overflow-wrap: break-word;
        color: rgba(144, 147, 157, 1);
        font-size: 12px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 15px;
        align-self: center;
        margin-top: 9px;
    }

    .box_17 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 9px;
        padding: 24px 38px 42px 39px;
    }

    .image-text_12 {
    }

    .image_12 {
        width: 96px;
        height: 96px;
        margin: 0 34px 0 33px;
    }

    .text-group_21 {
        margin-top: 7px;
    }

    .text_56 {
        overflow-wrap: break-word;
        color: rgba(46, 45, 62, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 23px;
    }



    .box_18 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 9px;
        padding: 24px 70px 42px 72px;
    }

    .image-text_13 {
    }



    .image_13 {
        width: 54px;
        height: 56px;
    }

    .text-group_22 {
        margin-top: 11px;
    }

    .text_58 {
        overflow-wrap: break-word;
        color: rgba(46, 45, 62, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        line-height: 23px;
    }

    @media (max-width: 480px) {

        .group_34 {
            padding: 10px 10px 10px 10px;
        }

        .text_52 {
            font-size: 25px;
            white-space: normal;
        }

        .text_53 {
            width: 60%;
            font-size: 13px;
            line-height: 1.5;
            height: auto;
            margin-top: -14px;
        }

        .box_15 {
            gap: 8px;
            margin-top: 10px;
        }

        .box_15 > div {
            padding: 10px 8px !important;
            border-radius: 6px;
        }
        .box_16,box_15 {
            min-width: 100px;
        }
        .text-group_20{
            width: 110px;
        }

        .image_11,
        .image_12,
        .image_13 {
            width: 60px !important;
            height: 60px !important;
        }

        .text_54,
        .text_56,
        .text_58 {
            font-size: 9px !important;
            line-height: 1.4 !important;
            white-space: normal;
        }

        .text_55 {
            font-size: 9px !important;
            margin-top: 6px !important;
        }

        /* 特殊调整第三列 */
        .box_18 {
            padding-left: 5px !important;
            padding-right: 5px !important;
        }

        .box_15 > div{
            flex: 1;
            min-width: 70px;
            max-width: 200px;
            box-sizing: border-box;
        }


    }

</style>
